export default __webpack_public_path__ + "fonts/launchpad_menu_cross.svg";